// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__8mjtw","subheader":"ReorderModal_subheader__2ZPbH","listWrap":"ReorderModal_listWrap__KVFFC"};